import React, { FC } from 'react';
import AddressForm, {
  FormData,
} from 'components/SalesArea/pages/AddressForm/AddressForm';
import {
  useCheckoutEmailUpdateMutation,
  useCheckoutShippingAddressUpdateMutation,
} from 'graphql/shopify-store-front-api/queries/types.d';

type Props = {
  /**
   * ページ切り替えに使用する関数
   */
  pagingFunction: VoidFunction;

  /**
   * Shopify支払いフォームのURL
   */
  checkoutURL: string;
};

const EnhancedAddressForm: FC<Props> = ({ pagingFunction, checkoutURL }) => {
  // チェックアウト情報に配送先情報を設定するためのhooks
  const [
    checkoutShippingAddressUpdateMutation,
    { loading: isCheckoutShippingAddressUpdateMutationLoading },
  ] = useCheckoutShippingAddressUpdateMutation({
    context: { clientName: 'shopify' },
  });

  // チェックアウト情報にメールアドレス情報を設定するためのhooks
  const [
    checkoutEmailUpdateMutation, // 設定処理を実行する関数
    {
      loading: checkoutEmailUpdateMutationLoading, // 設定処理実行中だけtrueになる
    },
  ] = useCheckoutEmailUpdateMutation();

  const onSubmit = (data: FormData) => {
    const submit = async () => {
      const checkoutPage = window.open('', '_blank');
      // 配送先情報設定
      await checkoutShippingAddressUpdateMutation({
        variables: {
          checkoutId: localStorage.getItem('checkoutId') ?? '',
          shippingAddress: {
            address1: data.address1,
            address2: data.address2,
            city: data.city,
            country: 'JP',
            firstName: data.firstName,
            lastName: data.lastName,
            phone: data.phone,
            province: data.province,
            zip: data.zip,
          },
        },
      });

      // メールアドレス設定
      await checkoutEmailUpdateMutation({
        variables: {
          checkoutId: localStorage.getItem('checkoutId') ?? '',
          email: data.email,
        },
      });

      if (checkoutPage) checkoutPage.location.href = checkoutURL;
      pagingFunction();
    };

    void submit();
  };

  return (
    <AddressForm
      onSubmit={onSubmit}
      isLoading={
        isCheckoutShippingAddressUpdateMutationLoading ||
        checkoutEmailUpdateMutationLoading
      }
    />
  );
};

export default EnhancedAddressForm;
